export default "__VITE_ASSET__BWj4nsp1__"